import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Las dietas restrictivas bajan tu energía, pero no movilizan el líquido estancado en tus tejidos.', 'Las fajas reductoras comprimen el problema, pero en realidad empeoran la circulación linfática a largo plazo.', 'Las cremas "quemadoras" son superficiales y no llegan al sistema linfático, que corre justo debajo de la piel.', 'El ejercicio intenso sin drenaje puede inflamar aún más los tejidos si tu cuerpo no tiene una vía de salida para las toxinas.'];
  return <section className="py-16 md:py-24 px-4 bg-[#FAF3E8]" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F] mb-6 text-center" data-id="element-141">
            La Verdad Sobre la Inflamación Crónica
          </h2>
          <p className="text-lg text-[#5A4332] leading-relaxed" data-id="element-142">
            La mayoría de las mujeres de 35 a 55 años viven en un estado de
            inflamación crónica. El estrés, los cambios hormonales y pasar horas
            sentada colapsan tus ganglios linfáticos. El líquido se acumula
            entre tus tejidos, creando esa apariencia de "pancita" blanda,
            celulitis y pesadez que te hace querer usar ropa holgada incluso en
            verano.
            <br data-id="element-143" />
            <br data-id="element-144" />
            Te sientes hinchada al despertar, más inflamada al terminar el día,
            y esa sensación de "globo" en el abdomen te quita la confianza de
            lucir un traje de baño o un vestido ajustado.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-[#D4654A]/20" data-id="element-145">
          <h3 className="text-2xl font-heading font-bold text-[#D4654A] mb-8 text-center" data-id="element-146">
            Por qué lo que has intentado NO ha funcionado
          </h3>
          <div className="space-y-6" data-id="element-147">
            {failedAttempts.map((attempt, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-148">
                <XCircleIcon className="w-6 h-6 text-[#D4654A] shrink-0 mt-1" data-id="element-149" />
                <p className="text-[#5A4332] text-lg" data-id="element-150">{attempt}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}